var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "325px",
    viewBox: "0 0 20 325",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-542.000000, -6309.000000)",
    stroke: "#121212",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/Contact",
    transform: "translate(-1.000000, 6301.833333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(543.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-contact",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10.1666667,
    x2: 10,
    y2: 304,
    id: "Line-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.98999995,
    cx: 10,
    cy: 314,
    r: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 5,
    r: 3.75
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowContact);
export default __webpack_public_path__ + "static/media/arrow-contact.2baa7c87dfb96219ec4beed4f9111c1c.svg";
export { ForwardRef as ReactComponent };